var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComplianceMadeSimple(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m.516 189.341 142.043-164.257a2.066 2.066 0 0 1 2.89-.2l210.409 181.942a2.105 2.105 0 0 1 .2 2.92l-142.039 164.254a2.1 2.1 0 0 1 -2.92.205l-210.379-181.945a2.048 2.048 0 0 1 -.2-2.919z",
    fill: "#006694"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m94.773 112.014 99.162-45.214 161.923 140.026a2.105 2.105 0 0 1 .2 2.92l-142.039 164.254a2.1 2.1 0 0 1 -2.92.205l-10.07-8.728-110.459-242.224a8.5 8.5 0 0 1 4.2-11.239z",
    fill: "#005c85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m97.43 117.852 197.593-90.083a2.063 2.063 0 0 1 2.715 1.022l115.392 253.086a2.05 2.05 0 0 1 -.992 2.744l-197.594 90.079a2.106 2.106 0 0 1 -2.744-1.022l-115.392-253.078a2.087 2.087 0 0 1 1.022-2.744z",
    fill: "#60b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.719 86.852h109.5l88.911 195.025a2.05 2.05 0 0 1 -.992 2.744l-197.594 90.079a2.106 2.106 0 0 1 -2.744-1.022l-5.546-12.2v-266.132a8.476 8.476 0 0 1 8.465-8.494z",
    fill: "#56a5e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m214.719 93.274h161.718l57.506 57.506v222.7a2.081 2.081 0 0 1 -2.072 2.073h-217.152a2.056 2.056 0 0 1 -2.043-2.073v-278.134a2.055 2.055 0 0 1 2.043-2.072z",
    fill: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m376.437 93.274v44.6a12.925 12.925 0 0 0 12.9 12.9h44.6z",
    fill: "#bec7cf"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.46 289.379h169.688a32.559 32.559 0 0 1 32.46 32.46v133.315a32.541 32.541 0 0 1 -32.46 32.461h-300.842a32.56 32.56 0 0 1 -32.461-32.461v-198.236a26.723 26.723 0 0 1 26.681-26.651h56.659c9.4 0 15.793 5.78 22.506 12.319l35.263 34.474c6.714 6.568 13.107 12.319 22.506 12.319z",
    fill: "#ffba57"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m248.026 149.992a7.211 7.211 0 0 1 0-14.421h95.338a7.211 7.211 0 0 1 0 14.421zm0 105.2a7.21 7.21 0 1 1 0-14.42h150.567a7.21 7.21 0 1 1 0 14.42zm0-35.058a7.211 7.211 0 0 1 0-14.421h150.567a7.211 7.211 0 1 1 0 14.421zm0-35.059a7.21 7.21 0 1 1 0-14.42h150.567a7.21 7.21 0 1 1 0 14.42z",
    fill: "#bec7cf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m146.646 400.567a7.21 7.21 0 1 1 0-14.42h70.321a7.21 7.21 0 0 1 0 14.42zm0 49.245a7.21 7.21 0 1 1 0-14.42h274.161a7.21 7.21 0 1 1 0 14.42z",
    fill: "#cf9646"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m433.943 294.837a32.489 32.489 0 0 1 14.509 27v133.317a32.542 32.542 0 0 1 -32.461 32.461h18.157a32.541 32.541 0 0 0 32.46-32.461v-133.315a32.018 32.018 0 0 0 -2.481-12.406 32.6 32.6 0 0 0 -29.979-20.054h-18.157a32.239 32.239 0 0 1 17.952 5.458zm-191.989-17.777-29.278-28.607-5.985-5.867c-6.713-6.539-13.106-12.319-22.506-12.319h-18.127c9.37 0 15.763 5.78 22.477 12.319l24.141 23.586 11.151 10.888c6.684 6.568 13.077 12.319 22.477 12.319h18.156c-9.4 0-15.792-5.751-22.506-12.319z",
    fill: "#e6a74e",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m450.553 385.213a61.447 61.447 0 1 0 -61.447-61.447 61.562 61.562 0 0 0 61.447 61.447z",
    fill: "#25c73b",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m413.831 332.114a7.214 7.214 0 1 1 10.188-10.214l13.836 13.836 39.2-39.2a7.2 7.2 0 0 1 10.188 10.187l-44.309 44.307a7.223 7.223 0 0 1 -10.187 0z",
    fill: "#eaf6ff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m445.328 262.523a61.46 61.46 0 0 1 3.124 122.135c-1.022.146-2.073.263-3.124.35 1.051.088 2.073.146 3.124.176.7.029 1.4.029 2.1.029a60.705 60.705 0 0 0 16.055-2.131 61.449 61.449 0 0 0 -16.055-120.763c-1.752 0-3.5.058-5.225.2z",
    fill: "#21b335",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m420.807 150.78v119.187a60.88 60.88 0 0 1 13.136-5.371v-113.816z",
    fill: "#d3dde6",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplianceMadeSimple);
export default __webpack_public_path__ + "static/media/compliance-made-simple.09941bb5399688043475f3f4251cbd32.svg";
export { ForwardRef as ReactComponent };